// client/src/pages/UserLogin/index.jsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState, useAuth } from '../../context/AuthContext';
import { Logo } from '../../components/Logo';
import {
  LoginContainer,
  LoginForm,
  LogoWrapper,
  Title,
  Subtitle,
  InputGroup,
  Label,
  Input,
  Button,
  Spinner,
  ErrorMessage,
  LinksContainer,
  LinkText,
  LoadingContainer,
  LoadingSpinner,
  LoadingText,
} from './styles';

const UserLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { isLoggedIn, loading: authLoading } = useAuthState();
  const { login } = useAuth();

  const navigate = useNavigate();

  // בדיקה אם המשתמש כבר מחובר
  useEffect(() => {
    if (authLoading) return;

    if (isLoggedIn) {
      navigate('/user/dashboard');
    }
  }, [navigate, isLoggedIn, authLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(formData);
      if (result.success) {
        navigate('/user/dashboard');
      } else {
        setError(result.message || 'שגיאה בהתחברות');
        console.log('Login failed:', result);
      }
    } catch (error) {
      setError('שגיאה בהתחברות. נסה שוב');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  // אם עדיין בוחן אימות, הצג טעינה
  if (authLoading) {
    return (
      <LoginContainer>
        <LoadingContainer>
          <LoadingSpinner />
          <LoadingText>טוען...</LoadingText>
        </LoadingContainer>
      </LoginContainer>
    );
  }

  // אם כבר מחובר, אל תציג כלום (הניווט יקרה)
  if (isLoggedIn) {
    return null;
  }

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit}>
        <LogoWrapper>
          <Logo size={120} />
        </LogoWrapper>

        <Title>ברוכים הבאים!</Title>
        <Subtitle>התחברו למערכת הלימוד שלכם</Subtitle>

        {error && <ErrorMessage>⚠️ {error}</ErrorMessage>}

        <InputGroup>
          <Label>אימייל</Label>
          <Input
            type='email'
            name='email'
            value={formData.email}
            onChange={handleChange}
            required
            disabled={loading}
            placeholder='הכנס כתובת אימייל'
          />
        </InputGroup>

        <InputGroup style={{ marginBottom: '28px' }}>
          <Label>סיסמה</Label>
          <Input
            type='password'
            name='password'
            value={formData.password}
            onChange={handleChange}
            required
            disabled={loading}
            placeholder='הכנס סיסמה'
          />
        </InputGroup>

        <Button type='submit' disabled={loading}>
          {loading ? (
            <>
              <Spinner />
              מתחבר...
            </>
          ) : (
            'התחבר'
          )}
        </Button>

        <LinksContainer>
          <LinkText
            onClick={() => !loading && navigate('/user/register')}
            disabled={loading}
          >
            אין לך חשבון? הירשם כאן
          </LinkText>

          <LinkText
            onClick={() => !loading && navigate('/admin/login')}
            disabled={loading}
            secondary
            small
          >
            כניסת מנהל
          </LinkText>
        </LinksContainer>
      </LoginForm>
    </LoginContainer>
  );
};

export default UserLogin;
